module.exports = __webpack_public_path__ + "static/media/schedule.50033b14.svg";